import React, { useEffect, useRef, useState, useContext } from "react";
import Slider from "react-slick";
import Button from "../../components/button/button";
import PlayButton from "../../components/button/playButton";
import { useLocation, useNavigate } from "react-router-dom";
import CreateAccountModal from '../../pages/signup/signup';
import LoginModal from "../login/login";
import SidebarContext from "../../contexts/MyContext";
import Modal from "../../components/Modal/Modal";
import { AudioHandler } from "../../Apihander/AudioRecording/AudioRecording";
import { successToast, errorToast } from "../../utils/notificationUtils";
import { micErrorMessage } from "../../utils/micErrorMessage";
import { formatTime, formatTimeInHHMMSS } from "../../utils/timeFile";
import { generateRandomNumber } from "../../utils/generateRandomNumber";
import FAQAccordion from "../../components/FAQAccordion/FAQAccordion";
import { convertToCaf, convertToM4a, convertToMp3, convertToWav, handleAudioConversion, safeConvertToM4a } from "../RecordingFeatures/convertToMp3";
import UserReviews from "../../components/userReview/userReview";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import StepsSection from "../../components/StepsSection/StepsSection";
import WhyChooseSection from "../../components/WhyChooseSection/WhyChooseSection";
import BlogSection from "../../components/BlogSection/BlogSection";
import AiFeaturesSection from "../../components/AiFeaturesSection/AiFeaturesSection";
import FeatureHighlights from "../../components/FeatureHighlights/FeatureHighlights";





const HomePage = () => {
    const navigate = useNavigate()
    const { user, setUser, setTabIndex, selectedFormat, isLoginCancel, setIsLoginCancel, isRecording, setIsRecording,

        mediaRecorderRef,
        shouldUploadRef,
        mediaStreamRef,
        elapsedTimeRef,
        elapsedTime, setElapsedTime, resetRecording, intervalRef, userReviews, sectionRef,
        recordingStart, setRecordingStart
        , loginModalOpen, setLoginModalOpen,
        isPaused, setIsPaused,
        btntoggl, setBtnToggl,
        audioBlobUrl, setAudioBlobUrl,

        alertModal, setAlertModal,
        eventClick, setEventClick,
        handleSaveAudioRecording,
        setPendingGuestRecording

    } = useContext(SidebarContext);


    const [openIndex, setOpenIndex] = useState(new Set());
    // const [recordingStart, setRecordingStart] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [collapsedIds, setCollapsedIds] = useState(new Set());
    const [signUpModalOpen, setSignUpModalOpen] = useState(false);
    // const [loginModalOpen, setLoginModalOpen] = useState(false);
    const [openModal, setOpenModal] = useState(false)
    const [audioName, setAudioName] = useState("")
    // const [audioBlobUrl, setAudioBlobUrl] = useState(null);
    // const [isPaused, setIsPaused] = useState(false);
    const [time, setTime] = useState()
    // const [isRecording, setIsRecording] = useState(false);
    const [load, setLoading] = useState(false)
    // const [btntoggl, setBtnToggl] = useState(false)
    const audioChunksRef = useRef([]);
    const sliderRef = React.useRef(null);
    const maxLength = 100; // Define the maximum length
    // const [isLoginCancel, setIsLoginCancel] = useState(false)
    const [isDownloading, setIsDownloading] = useState(false);
    const audioBlobRef = useRef(null);
    const [showAppStoreImage, setShowAppStoreImage] = useState(false);
    const [showPlayStoreImage, setShowPlayStoreImage] = useState(false);
    const [downloadUrl, setDownloadUrl] = useState(null);
    // const intervalRef = useRef(null);
    // const [elapsedTime, setElapsedTime] = useState(0);
    // const mediaRecorderRef = useRef(null);
    // const shouldUploadRef = useRef(true);
    // const mediaStreamRef = useRef(null);
    // const elapsedTimeRef = useRef(0);
    const location = useLocation()



    useEffect(() => {
        setTabIndex(1)
        // Reset recording states on page refresh
        // setRecordingStart(false)
        // setIsLoginCancel(false)
        // setBtnToggl(false)
        // setElapsedTime(0)
        // setAudioBlobUrl(null)
        // setAudioName("")
    }, [])

    // Log downloadUrl when it changes
    useEffect(() => {
        if (downloadUrl) {
            console.log("🔄 downloadUrl state updated:", downloadUrl);
        }
    }, [downloadUrl])


    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: false,
        beforeChange: (current, next) => setCurrentSlide(next),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const handleNextClick = () => {
        if (currentSlide < featuresData.length - 1) {
            // Update currentSlide state and trigger slide change
            setCurrentSlide(currentSlide + 1);
            sliderRef.current.slickGoTo(currentSlide + 1); // Programmatically go to next slide
        }
    };

    const handlePreviousClick = () => {
        if (currentSlide > 0) {
            setCurrentSlide(currentSlide - 1);
            sliderRef.current.slickGoTo(currentSlide - 1);
        }
    };

    const featuresData = [
        {
            icon: "/img/features/recording_icon.png",
            altIcon: 'recording-mic',
            title: "Online Voice Recorder",
            des: "Record your voice online and enjoy a premium sound experience that’s fast, reliable, and works across devices.",
            img: "/img/features/recording_img.png",
            altImg: 'voice-recording '
        },
        {
            icon: "/img/features/trim_icon.png",
            altIcon: 'Voice-Trim',
            title: "Easy Trim Audio",
            des: "Get polished recordings in minutes. Trim to remove the bits you don’t want, edit out mistakes, and refine your audio with ease.",
            img: "/img/features/trim_img.png",
            altImg: 'Voice-Record-Trim'

        },
        {
            icon: "/img/features/adjust_icon.svg",
            altIcon: 'Audio-Adjuster',
            title: "Audio Adjuster",
            des: "Remove background noise, lift quiet audio and change the playback speed from 0.5x to 2x until your recording sounds right.",
            img: "/img/features/adjust_img.svg",
            altImg: 'voice-record-audio-adjust'
        },
        {
            icon: "/img/features/extract_icon.svg",
            altIcon: 'Extract-Audio',
            title: "Extract Audio From Video",
            des: "Upload an MP4, MOV or WebM video and pull the sound straight out of it, ready to edit alongside everything else you record.",
            img: "/img/features/extract_img.svg",
            altImg: 'extract-audio-from-video'
        },
        {
            icon: "/img/features/merge_icon.png",
            altIcon: 'Voice-Merge',
            title: "Easy Merge Audio",
            des: "Combine multiple audio files into a single, seamless recording. Perfect for podcasters, interviewers, and content creators.",
            img: "/img/features/merge_img.png",
            altImg: 'Voice-Record-Merge'

        },
        {
            icon: "/img/features/convert_icon.png",
            altIcon: 'Voice-convert',
            title: "Online Audio Converter",
            des: "Use our built-in mp3 recorder to convert your recordings into widely used formats like MP3. Make sure all devices are compatible.",
            img: "/img/features/convert_img.png",
            altImg: 'mp3-to-wav-convert'
        },
        {
            icon: "/img/features/transcript_icon.png",
            altIcon: '',
            title: "AI Transcription & Summary",
            des: "Turn your audio into an editable transcript with an AI summary alongside it, perfect for meetings, lectures and interviews.",
            img: "/img/features/transcript_img.png",
            altImg: 'Voice-transcript'
        },
        {
            icon: "/img/features/tts_icon.svg",
            altIcon: 'Text-to-Speech',
            title: "Text to Speech",
            des: "Turn any text into a natural sounding voice, up to 5,000 characters at a time, then save it with the rest of your recordings.",
            img: "/img/features/tts_img.svg",
            altImg: 'text-to-speech-voice'
        },
        {
            icon: "/img/features/note_icon.svg",
            altIcon: 'Recording-Notes',
            title: "Notes On Recordings",
            des: "Write a note against any recording so the context stays with the audio, and find it again without replaying the whole file.",
            img: "/img/features/note_img.svg",
            altImg: 'voice-record-notes'
        },
        {
            icon: "/img/features/cloudsync_icon.png",
            altIcon: '',
            title: "Cloud Storage",
            des: "Is music your go-to mood booster? Save your favorite recordings in the cloud and listen anywhere- no downloads, no storage hassles!",
            img: "/img/features/cloudsync_img.png",
            altImg: 'voice-record-cloudsync'
        },
    ];


    const handleItemClick = (index) => {
        setOpenIndex(index === openIndex ? null : index);
    };

    const handleToggleCollapse = (id) => {
        setCollapsedIds((prevIds) => {
            const newSet = new Set(prevIds);
            if (newSet.has(id)) {
                newSet.delete(id);
            } else {
                newSet.add(id);
            }
            return newSet;
        });
    };

    const handleStartRecordingScroll = () => {
        const heroSection = document.getElementById("hero-section");
        // if (heroSection) {
        //     heroSection.scrollIntoView({ behavior: "smooth" });
        // }

        if (heroSection) {
            const offset = 120; // Adjust this value based on your navbar height
            const elementPosition = heroSection.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    }

    const signUpOpenModal = () => {

        setSignUpModalOpen(true);
    };

    const signUpCloseModal = () => {
        setSignUpModalOpen(false);
    };

    const loginOpenModal = () => {
        setLoginModalOpen(true);
        pauseRecording()
    };

    const loginCloseModal = () => {
        setLoginModalOpen(false);
        stopRecording();
        if (recordingStart) {
            setIsLoginCancel(true)
            setBtnToggl(false)
        }

    };

    const handleGetStarted = () => {
        if (user) {
            navigate("/dashboard")
        } else if (!user && recordingStart) {
            handleSaveAudioRecording("isSignup")
            setAlertModal(true)
            setEventClick("isSignUp")
        }
        else {
            signUpOpenModal()
        }
    }

    const handleClose = () => {
        setOpenModal(false);
        setAudioName('')
        setAudioBlobUrl("")
        setRecordingStart(false)
        setBtnToggl(false); // Reset the button toggle state when modal is closed

    }

    // auto stop after 1 minute

    // const startRecording = async () => {
    //     try {
    //         // 1. Check mic permission state first
    //         let permissionStatus;
    //         try {
    //             permissionStatus = await navigator.permissions.query({ name: "microphone" });
    //             console.log("Microphone permission state:", permissionStatus.state);

    //             if (permissionStatus.state === "denied") {
    //                 // alert("🚫 Microphone access is blocked. Please enable it in your browser site settings.");
    //                 return;
    //             }
    //         } catch (permErr) {
    //             console.warn("Permissions API not supported in this browser:", permErr);
    //         }
    //         console.log('Starting recording...');
    //         const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    //         console.log('Stream obtained:', stream);
    //         mediaRecorderRef.current = new MediaRecorder(stream, { mimeType: 'audio/mp4' });
    //         console.log('MediaRecorder created:', mediaRecorderRef.current);
    //         mediaStreamRef.current = stream;
    //         audioChunksRef.current = []; // Reset audio chunks at the start of recording

    //         mediaRecorderRef.current.ondataavailable = event => {
    //             audioChunksRef.current.push(event.data);
    //         };

    //         mediaRecorderRef.current.onstop = async () => {

    //             if (mediaStreamRef.current) {
    //                 mediaStreamRef.current.getTracks().forEach((track) => track.stop());
    //                 mediaStreamRef.current = null; // Clear the MediaStream
    //             }
    //             // Check the flag to determine if upload should be skipped
    //             if (!shouldUploadRef.current) {
    //                 shouldUploadRef.current = true; // Reset flag for the next recording
    //                 return; // Skip upload
    //             }
    //             // Ensure chunks exist
    //             if (audioChunksRef.current.length === 0) {
    //                 console.error("No audio chunks available for creating audio blob.");
    //                 return;
    //             }

    //             try {
    //                 // Create the audio blob after recording stops
    //                 const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/mp4' });
    //                 audioChunksRef.current = [];

    //                 let mp3Blob;
    //                 try {
    //                     if (selectedFormat == "mp3") {
    //                         mp3Blob = await convertToMp3(audioBlob);
    //                     } else if (selectedFormat == "wav") {
    //                         mp3Blob = await convertToWav(audioBlob);
    //                     }
    //                     else if (selectedFormat == "caf") {
    //                         mp3Blob = await convertToCaf(audioBlob);
    //                     }
    //                     else if (selectedFormat == "m4a") {
    //                         // mp3Blob = await convertToM4a(audioBlob);
    //                         mp3Blob = audioBlob;
    //                     }
    //                     else if (selectedFormat == "") {
    //                         mp3Blob = await convertToMp3(audioBlob);
    //                     }
    //                     else {
    //                         throw new Error("Unsupported audio format");
    //                     }

    //                     // Generate a random audio name
    //                     const randomAudioName = `Voice${generateRandomNumber()}`;
    //                     setAudioName(randomAudioName);

    //                     // Create audio URL and set audioBlobUrl in state
    //                     const audioUrl = URL.createObjectURL(mp3Blob);
    //                     // console.log(mp3Blob, "mp3Blob", audioUrl);

    //                     setAudioBlobUrl(audioUrl);
    //                     audioBlobRef.current = mp3Blob;
    //                     await doHandalUploadAudioUrl(mp3Blob, randomAudioName, elapsedTimeRef.current);
    //                 } catch (conversionError) {
    //                     console.error("Audio conversion error:", conversionError);
    //                     // Handle conversion error (e.g., show error message to user)
    //                 }
    //             } catch (blobError) {
    //                 console.error("Error creating audio blob:", blobError);
    //             } finally {
    //                 // Clear the interval and reset elapsed time
    //                 clearInterval(intervalRef.current);
    //                 // elapsedTimeRef.current = 0;
    //             }
    //         };

    //         // Start recording
    //         mediaRecorderRef.current.start();
    //         setIsRecording(true);
    //         elapsedTimeRef.current = 0;


    //         // Check recording time and handle conditions
    //         intervalRef.current = setInterval(() => {
    //             elapsedTimeRef.current += 1;
    //             setElapsedTime(elapsedTimeRef.current);

    //             if (elapsedTimeRef.current >= 300) { // 300 seconds
    //                 if (user) {
    //                     if (!user?.isSubscriptionActive) {
    //                         // Only pause and stop for non-subscribed users
    //                         mediaRecorderRef.current.resume();
    //                         setIsRecording(false);
    //                         setIsPaused(true);
    //                         clearInterval(intervalRef.current);
    //                         setRecordingStart(true);
    //                         setIsLoginCancel(false);
    //                         stopRecording();
    //                         navigate('/pricing');
    //                     }
    //                     // For subscribed users, continue recording
    //                 } else {
    //                     // For non-logged in users, pause and show login modal
    //                     mediaRecorderRef.current.resume();
    //                     setIsRecording(false);
    //                     setIsPaused(true);
    //                     clearInterval(intervalRef.current);
    //                     setRecordingStart(true);
    //                     setIsLoginCancel(true);
    //                     loginOpenModal();
    //                 }
    //             }
    //         }, 1000);
    //     } catch (err) {
    //         console.error('Failed to start recording', err);
    //         console.error('Error name:', err.name);
    //         console.error('Error message:', err.message);
    //         // Handle microphone access error (e.g., show error message to user)
    //     }
    // };



    //     const startRecording = async () => {
    //     try {
    //         console.log("🔊 Checking microphone permission...");
    //         // 1. Check mic permission state first
    //         let permissionStatus;
    //         try {
    //             permissionStatus = await navigator.permissions.query({ name: "microphone" });
    //             console.log("Microphone permission state:", permissionStatus.state);

    //             if (permissionStatus.state === "denied") {
    //                 // alert("🚫 Microphone access is blocked. Please enable it in your browser site settings.");
    //                 return;
    //             }
    //         } catch (permErr) {
    //             console.warn("Permissions API not supported in this browser:", permErr);
    //         }
    //         // 2. Request mic access (this triggers the browser popup if needed)
    //         const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    //         console.log("✅ Microphone stream obtained:", stream);

    //         // 3. Pick safe MIME type (fallback if unsupported)
    //         let options = {};
    //         if (MediaRecorder.isTypeSupported("audio/webm")) {
    //             options.mimeType = "audio/webm";
    //         } else if (MediaRecorder.isTypeSupported("audio/mp4")) {
    //             options.mimeType = "audio/mp4";
    //         } else {
    //             options.mimeType = ""; // Let browser decide
    //         }

    //         mediaRecorderRef.current = new MediaRecorder(stream, options);
    //         console.log("🎙️ MediaRecorder created with:", options.mimeType);

    //         mediaStreamRef.current = stream;
    //         audioChunksRef.current = [];

    //         mediaRecorderRef.current.ondataavailable = (event) => {
    //             if (event.data.size > 0) {
    //                 audioChunksRef.current.push(event.data);
    //             }
    //         };

    //         mediaRecorderRef.current.onstop = async () => {
    //             console.log("🛑 Recording stopped");

    //             if (mediaStreamRef.current) {
    //                 mediaStreamRef.current.getTracks().forEach((track) => track.stop());
    //                 mediaStreamRef.current = null;
    //             }

    //             if (audioChunksRef.current.length === 0) {
    //                 console.error("No audio chunks available.");
    //                 return;
    //             }

    //             try {
    //                 const audioBlob = new Blob(audioChunksRef.current, { type: options.mimeType || "audio/webm" });
    //                 audioChunksRef.current = [];

    //                 let finalBlob = audioBlob;

    //                 if (selectedFormat === "mp3") {
    //                     finalBlob = await convertToMp3(audioBlob);
    //                 } else if (selectedFormat === "wav") {
    //                     finalBlob = await convertToWav(audioBlob);
    //                 } else if (selectedFormat === "caf") {
    //                     finalBlob = await convertToCaf(audioBlob);
    //                 } else if (selectedFormat === "m4a") {
    //                     finalBlob = audioBlob; // keep as-is
    //                 }

    //                 const randomAudioName = `Voice${generateRandomNumber()}`;
    //                 setAudioName(randomAudioName);

    //                 const audioUrl = URL.createObjectURL(finalBlob);
    //                 setAudioBlobUrl(audioUrl);
    //                 audioBlobRef.current = finalBlob;

    //                 await doHandalUploadAudioUrl(finalBlob, randomAudioName, elapsedTimeRef.current);
    //             } catch (err) {
    //                 console.error("❌ Error handling audio blob:", err);
    //             } finally {
    //                 clearInterval(intervalRef.current);
    //             }
    //         };

    //         // 4. Start recording
    //         mediaRecorderRef.current.start();
    //         console.log("⏺️ Recording started...");
    //         setIsRecording(true);
    //         elapsedTimeRef.current = 0;

    //         intervalRef.current = setInterval(() => {
    //             elapsedTimeRef.current += 1;
    //             setElapsedTime(elapsedTimeRef.current);

    //             if (elapsedTimeRef.current >= 300) { // 5 min limit
    //                 stopRecording();
    //                 if (user && !user?.isSubscriptionActive) {
    //                     navigate("/pricing");
    //                 } else if (!user) {
    //                     loginOpenModal();
    //                 }
    //             }
    //         }, 1000);

    //     } catch (err) {
    //         console.error("❌ Failed to start recording:", err);
    //         alert("Microphone permission is required to record audio. Please allow access.");
    //     }
    // };

    const startRecording = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            mediaRecorderRef.current = new MediaRecorder(stream, { mimeType: 'audio/mp4' });
            mediaStreamRef.current = stream;
            audioChunksRef.current = []; // Reset audio chunks at the start of recording

            mediaRecorderRef.current.ondataavailable = event => {
                audioChunksRef.current.push(event.data);
            };

            mediaRecorderRef.current.onstop = async () => {

                if (mediaStreamRef.current) {
                    mediaStreamRef.current.getTracks().forEach((track) => track.stop());
                    mediaStreamRef.current = null; // Clear the MediaStream
                }
                // Check the flag to determine if upload should be skipped
                if (!shouldUploadRef.current) {
                    shouldUploadRef.current = true; // Reset flag for the next recording
                    return; // Skip upload
                }
                // Ensure chunks exist
                if (audioChunksRef.current.length === 0) {
                    console.error("No audio chunks available for creating audio blob.");
                    return;
                }

                try {
                    // Create the audio blob after recording stops
                    const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/mp4' });
                    audioChunksRef.current = [];

                    let mp3Blob;
                    try {
                        if (selectedFormat == "mp3") {
                            mp3Blob = await convertToMp3(audioBlob);
                        } else if (selectedFormat == "wav") {
                            mp3Blob = await convertToWav(audioBlob);
                        }
                        else if (selectedFormat == "caf") {
                            mp3Blob = await convertToCaf(audioBlob);
                        }
                        else if (selectedFormat == "m4a") {
                            // mp3Blob = await convertToM4a(audioBlob);
                            mp3Blob = audioBlob;
                        }
                        else if (selectedFormat == "") {
                            mp3Blob = await convertToMp3(audioBlob);
                        }
                        else {
                            throw new Error("Unsupported audio format");
                        }

                        // Generate a random audio name
                        const randomAudioName = `Voice${generateRandomNumber()}`;
                        setAudioName(randomAudioName);

                        // Create audio URL and set audioBlobUrl in state
                        const audioUrl = URL.createObjectURL(mp3Blob);
                        // console.log(mp3Blob, "mp3Blob", audioUrl);

                        setAudioBlobUrl(audioUrl);
                        audioBlobRef.current = mp3Blob;
                        // Guests have no auth token, so the upload endpoint would 401 and
                        // trigger the global handle401Error logout/redirect. Keep guest
                        // recordings local-only (used by handleDownloadClick's guest branch).
                        if (user) {
                            await doHandalUploadAudioUrl(mp3Blob, randomAudioName, elapsedTimeRef.current);
                        } else {
                            // Handed to the provider, which uploads it as soon as the visitor logs in.
                            setPendingGuestRecording({
                                blob: mp3Blob,
                                fileName: `${randomAudioName}.${selectedFormat || "mp3"}`,
                                duration: elapsedTimeRef.current,
                            });
                        }
                    } catch (conversionError) {
                        console.error("Audio conversion error:", conversionError);
                        // Handle conversion error (e.g., show error message to user)
                    }
                } catch (blobError) {
                    console.error("Error creating audio blob:", blobError);
                } finally {
                    // Clear the interval and reset elapsed time
                    clearInterval(intervalRef.current);
                    // elapsedTimeRef.current = 0;
                }
            };

            // Start recording
            mediaRecorderRef.current.start();
            setIsRecording(true);
            elapsedTimeRef.current = 0;


            // Check recording time and handle conditions
            intervalRef.current = setInterval(() => {
                elapsedTimeRef.current += 1;
                setElapsedTime(elapsedTimeRef.current);

                if (elapsedTimeRef.current >= 300) { // 300 seconds
                    if (user) {
                        if (!user?.isSubscriptionActive) {
                            // Only pause and stop for non-subscribed users
                            mediaRecorderRef.current.resume();
                            setIsRecording(false);
                            setIsPaused(true);
                            clearInterval(intervalRef.current);
                            setRecordingStart(true);
                            setIsLoginCancel(false);
                            stopRecording();
                            navigate('/pricing');
                        }
                        // For subscribed users, continue recording
                    } else {
                        // For non-logged in users, pause and show login modal
                        mediaRecorderRef.current.resume();
                        setIsRecording(false);
                        setIsPaused(true);
                        clearInterval(intervalRef.current);
                        setRecordingStart(true);
                        setIsLoginCancel(true);
                        loginOpenModal();
                    }
                }
            }, 1000);
        } catch (err) {
            console.error('Failed to start recording', err);
            errorToast(micErrorMessage(err));
        }
    };


    const stopRecording = () => {
        if (mediaRecorderRef.current) {
            mediaRecorderRef.current.stop();
            setIsRecording(false);
            clearInterval(intervalRef.current);
            setElapsedTime(elapsedTimeRef.current);


            if (elapsedTimeRef.current > 0) {
                setElapsedTime(elapsedTimeRef.current);
            }

        }
    };

    const pauseRecording = () => {
        if (mediaRecorderRef.current) {
            if (mediaRecorderRef.current.state === 'recording') {
                mediaRecorderRef.current.pause();
                setIsPaused(true);
                clearInterval(intervalRef.current);
                // console.log('Recording paused...');
            } else if (mediaRecorderRef.current.state === 'paused') {
                mediaRecorderRef.current.resume();
                setIsPaused(false);
                intervalRef.current = setInterval(() => {
                    elapsedTimeRef.current += 1;
                    setElapsedTime(elapsedTimeRef.current);
                }, 1000);
                // console.log('Recording resumed...');
            }
        }
    };



    // const resetRecording = () => {
    //     if (mediaRecorderRef.current) {
    //         shouldUploadRef.current = false; // Prevent upload on reset
    //         mediaRecorderRef.current.stop(); // Triggers the `onstop` event
    //         mediaRecorderRef.current = null; // Clear the MediaRecorder
    //     }

    //     if (mediaStreamRef.current) {
    //         mediaStreamRef.current.getTracks().forEach((track) => track.stop());
    //         mediaStreamRef.current = null; // Clear the MediaStream
    //     }

    //     setIsRecording(false);
    //     clearInterval(intervalRef.current); // Stop the timer
    //     setElapsedTime(0); // Reset the elapsed time
    //     elapsedTimeRef.current = 0; // Reset the reference for elapsed time
    // };

    // console.log(isRecording, location?.pathname, isRecording && location?.pathname == "/pricing", "5555555555");

    // useEffect(() => {
    //     console.log(window.location.pathname == "/", "45454545 upppp");

    //     return () => {
    //         resetRecording();
    //         console.log(window.location.pathname !== "/", "45454545 returnnn");

    //     };
    // }, []);

    const doHandalUploadAudioUrl = async (audioBlob, audioName, elapsedTime) => {
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append('audiofile', audioBlob, `${audioName}.${selectedFormat || "mp3"}`);
            formData.append('timeDuration', formatTimeInHHMMSS(elapsedTime));
            formData.append('action', 'Audio');

            const data = await AudioHandler.doUploadAudioUrl(formData);
            setDownloadUrl(data?.data?.audio?.url);
            if (data.statusCode === 200) {
                successToast(data?.message);
                if (!user?.isSubscriptionActive && elapsedTimeRef.current >= 300) {
                    // console.log(" I am non subscription");

                } else {

                    setRecordingStart(false)
                    setBtnToggl(false)
                    setIsLoginCancel(false)
                    setElapsedTime(0)
                    setTabIndex(2);
                    // navigate('/dashboard')
                }

                // setTabIndex(2); // Update the UI after success
            } else {
                const errorMessage =
                    data?.response?.data?.error ||
                    data?.response?.data?.message ||
                    data.message ||
                    "An error occurred";
                errorToast(errorMessage);
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                error?.message ||
                "An error occurred";
            errorToast(errorMessage);
        } finally {
            setLoading(false);
        }
    };



    const handleSaveAudioRecordingHome = () => {

        if (user) {
            setRecordingStart(true);
            stopRecording()
            setIsLoginCancel(false)
        }
        else {
            // stopRecording()
            loginOpenModal()
            setElapsedTime(elapsedTimeRef.current);


        }
    }

    const handleInputChange = (e) => {
        const inputValue = e.target.value;

        // Limit the length of the input value
        if (inputValue.length <= maxLength) {
            setAudioName(inputValue);
        }
    };


    const handleDownloadClick = async (e) => {
        // Use the actual audio name that was set during recording
        const downloadFileName = audioName ? `${audioName}.${selectedFormat || 'mp3'}` : `Voice${generateRandomNumber()}.${selectedFormat || 'mp3'}`;

        if (user) {
            // User is logged in - use server URL from downloadUrl
            if (downloadUrl && downloadFileName) {
                try {
                    console.log("📥 Downloading for logged-in user using server URL:", downloadUrl);

                    const response = await fetch(downloadUrl);  // 👈 state ma save karyu string URL use
                    const blob = await response.blob();
                    const blobUrl = window.URL.createObjectURL(blob);
                    // Create an anchor element and trigger the download
                    const link = document.createElement('a');
                    link.href = blobUrl; // Use the server URL
                    link.download = downloadFileName; // Set the file name for download
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    console.log("✅ Download initiated for logged-in user");
                } catch (error) {
                    console.error("❌ Error downloading the audio file:", error);
                }
            } else {
                console.error("❌ Server URL or filename is missing for logged-in user!");
                console.error("downloadUrl:", downloadUrl);
            }
        } else {
            // User is not logged in - use local blob
            if (audioBlobUrl && downloadFileName) {
                try {
                    console.log("📥 Downloading for guest user using local blob");

                    // Create an anchor element and trigger the download
                    const link = document.createElement('a');
                    link.href = audioBlobUrl; // Use the local blob URL
                    link.download = downloadFileName; // Set the file name for download        
                    // Append the link to the body, trigger click, then remove the link           
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } catch (error) {
                    console.error("Error downloading the audio file:", error);
                }
            } else {
                console.error("Audio URL or filename is missing!");
            };
        };
    };


    const downloadAudioFile = (audioBlob, audioName) => {
        // Create a download link
        const downloadLink = document.createElement("a");
        const blobUrl = URL.createObjectURL(audioBlob); // Create a URL from the blob
        downloadLink.href = blobUrl;
        downloadLink.download = `${audioName}.${selectedFormat || 'mp3'}`; // Set file name and format

        // Programmatically click the link to trigger the download
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // Clean up the DOM and revoke the URL
        URL.revokeObjectURL(blobUrl);
        document.body.removeChild(downloadLink);
        setRecordingStart(false)
        setIsLoginCancel(false)
        setElapsedTime(0)
    };


    return (
        <>
            <div className="container" id="hero-section">

                {/* Hero section */}
                <div style={{ margin: "30px 0 0 0 " }}>
                    <div className="text-center">
                        <h1 style={{
                            marginBottom: "0", letterSpacing: "-1px",
                            fontSize: "48px",
                            fontWeight: "700",
                            fontFamily: "Metropolis"


                        }}>Online Voice Recorder For Free</h1>
                        <p
                            style={{
                                fontSize: "20px",
                                fontWeight: "400",
                                color: "#5F626B",
                                fontFamily: "Metropolis",
                                lineHeight: "24px",
                                letterSpacing: "-1px",
                            }}
                        >
                            Record, transcribe and edit professional audio instantly, with AI tools built right in.
                        </p>
                    </div>

                    <div style={{ maxWidth: "1020px", margin: "0 auto" }}>
                        <div
                            className="d-flex justify-content-center flex-column align-items-center hero_play_btn_bg"
                            style={{ padding: "40px 0px 15px 40px" }}
                        >
                            <div>
                                {!recordingStart || btntoggl || isLoginCancel ? (
                                    <img src="/img/hero/animation.png" alt="Voice-Recorder-Frequency" width={200} height={200} />
                                ) : (
                                    <img src="/img/hero/play.gif" alt="Voice-Recorder-Frequency" width={200} height={200} />
                                )}
                            </div>
                            <div
                                style={{
                                    fontSize: "48px",
                                    fontWeight: "700",
                                    display: "block",
                                }}
                            >
                                <span style={{ fontSize: "40px" }}>


                                    {/* {recordingStart ? formatTime(elapsedTime) : ""} */}
                                    {recordingStart
                                        ? `${formatTime(elapsedTime)}${!user?.isSubscriptionActive || !user ? " / 05:00" : ""}`
                                        : ""}
                                </span>

                            </div>
                            {!recordingStart ? (
                                <>
                                    <div style={{ marginTop: recordingStart ? "20px" : "95px" }}>
                                        <div className="d-flex">
                                            <PlayButton
                                                click={() => { setRecordingStart(true); startRecording(); }}
                                                src={"/img/button/music.png"}
                                                btnText={"Start Recording"}
                                                MainStartRecording
                                                altName='Play Button'
                                            />
                                            {user && audioBlobUrl && (
                                                <div style={{ marginLeft: "20px" }}>
                                                    <button
                                                        onClick={handleDownloadClick}
                                                        style={{
                                                            border: "none",
                                                            background: "#334155",
                                                            borderRadius: "8px",
                                                            padding: "14px 20px",
                                                            cursor: "pointer",
                                                            color: "#fff",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                        }}
                                                    >
                                                        <span style={{ fontWeight: "bold" }}>
                                                            <img
                                                                src={"/img/dashboard/download.png"}
                                                                alt={"download"}
                                                                style={{ marginRight: "10px" }}
                                                            />
                                                            Download
                                                        </span>
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                </>

                            ) : (
                                <>

                                    <div className="d-flex">
                                        {
                                            !btntoggl ? <div style={{ marginTop: recordingStart ? "20px" : "95px", marginRight: "20px" }}>
                                                {isLoginCancel ? (
                                                    <>
                                                        <PlayButton
                                                            click={!load ? () => {
                                                                setRecordingStart(true);
                                                                startRecording();
                                                                setIsLoginCancel(false);
                                                            } : undefined}
                                                            src={"/img/button/music.png"}
                                                            btnText={
                                                                load ? (
                                                                    <div
                                                                        className="spinner-border"
                                                                        role="status"
                                                                        style={{ width: "1.5rem", height: "1.5rem" }}
                                                                    />
                                                                ) : (
                                                                    "Start New Recording"
                                                                )
                                                            }
                                                            MainStartRecording
                                                            altName="Play Button"
                                                        />

                                                    </>) : (
                                                    <>
                                                        <PlayButton
                                                            click={() => {
                                                                if (!load) {
                                                                    setBtnToggl(true); pauseRecording()
                                                                }
                                                            }}
                                                            src={"/img/button/push.png"}
                                                            btnText={"Pause"}
                                                            border
                                                        />
                                                    </>)}

                                            </div> : <div style={{ marginTop: recordingStart ? "20px" : "95px", marginRight: "20px" }}>
                                                {isLoginCancel ? (
                                                    <>
                                                        <PlayButton
                                                            click={() => { setRecordingStart(true); startRecording(); setIsLoginCancel(false) }}
                                                            src={"/img/button/music.png"}
                                                            btnText={"Start New Recording "}
                                                            MainStartRecording
                                                            altName='Play Button'

                                                        />
                                                    </>) : (
                                                    <>
                                                        <PlayButton
                                                            click={() => {
                                                                if (!load) {
                                                                    setBtnToggl(false); pauseRecording()
                                                                }
                                                            }}
                                                            src={"/img/button/Vector.png"}
                                                            btnText={"Start"}
                                                            border
                                                        />
                                                    </>)}

                                            </div>
                                        }
                                        <div
                                            style={{ marginTop: recordingStart ? "20px" : "95px" }}
                                        >
                                            {isLoginCancel ? (
                                                <>
                                                    <button
                                                        onClick={(e) => handleDownloadClick(e)}
                                                        style={{
                                                            border: "none",
                                                            background: "#334155",
                                                            borderRadius: "8px",
                                                            padding: "14px 20px",
                                                            cursor: "pointer",
                                                            color: "#fff",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                        }}
                                                    >
                                                        {isDownloading ? (
                                                            <>
                                                                <div>
                                                                    <span className="sr-only" style={{ marginRight: "7px" }}>
                                                                        Downloading
                                                                    </span>
                                                                    <span
                                                                        className="spinner-grow spinner-grow-sm"
                                                                        role="status"
                                                                        aria-hidden="true"
                                                                        style={{
                                                                            height: "0.5rem",
                                                                            width: "0.5rem",
                                                                            marginRight: "1px",
                                                                        }}
                                                                    ></span>
                                                                    <span
                                                                        className="spinner-grow spinner-grow-sm"
                                                                        role="status"
                                                                        aria-hidden="true"
                                                                        style={{
                                                                            height: "0.5rem",
                                                                            width: "0.5rem",
                                                                            marginRight: "1px",
                                                                        }}
                                                                    ></span>
                                                                    <span
                                                                        className="spinner-grow spinner-grow-sm"
                                                                        role="status"
                                                                        aria-hidden="true"
                                                                        style={{ height: "0.5rem", width: "0.5rem" }}
                                                                    ></span>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <span style={{ fontWeight: "bold" }}>
                                                                    <img
                                                                        src={"/img/dashboard/download.png"}
                                                                        alt={"download"}
                                                                        style={{ marginRight: "10px" }}
                                                                    />
                                                                    Download
                                                                </span>
                                                            </>
                                                        )}
                                                    </button>
                                                </>) : (
                                                <PlayButton
                                                    click={() => {
                                                        if (elapsedTime >= 1) {
                                                            handleSaveAudioRecordingHome()
                                                        }
                                                    }
                                                    }
                                                    // src={"/img/button/stop.png"}
                                                    // btnText={"Stop"}
                                                    src={load ? "" : "/img/button/stop.png"}
                                                    btnText={load ? (
                                                        <div
                                                            className="spinner-border"
                                                            role="status"
                                                            style={{ width: "1.3rem", height: "1.3rem" }}
                                                        >
                                                            <span className="visually-hidden">Loading...</span>
                                                        </div>
                                                    ) : "Stop"}
                                                />
                                            )}
                                        </div>
                                    </div>

                                    {openModal && (
                                        <Modal onClose={() => handleClose()} modaltxt={"Save recording"}>
                                            <div>
                                                <div className="form-group mt-4 mb-4">
                                                    <input type="text" className="form-control   p-3 input-field" style={{ borderRadius: '8px' }} id="recordingname" name="recordingname" placeholder="Recording name" value={audioName}
                                                        onChange={(e) => handleInputChange(e)} />
                                                    <div style={{ fontSize: '14px', color: '#CBD5E1', marginTop: '5px', display: 'flex', justifyContent: 'end' }}>
                                                        {`${audioName?.length}/${maxLength}`}
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <button
                                                        type="submit"
                                                        // disabled={!audioName || load}
                                                        disabled={!(audioName.trim().length >= 3) || load}

                                                        onClick={(e) => {
                                                            if (!load) {
                                                                doHandalUploadAudioUrl(e)
                                                            }
                                                        }}
                                                        className="btn p-3"
                                                        style={{
                                                            width: "100%",
                                                            borderRadius: "8px",
                                                            background: "#334155",
                                                            fontSize: "16px",
                                                            fontWeight: "700",
                                                            color: "#FFFFFF",
                                                        }}
                                                    >
                                                        {load ? (
                                                            <>
                                                                <div
                                                                    className="spinner-border"
                                                                    role="status"
                                                                    style={{ width: "1.3rem", height: "1.3rem" }}
                                                                >
                                                                    <span className="visually-hidden">Loading...</span>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <span>
                                                                    Save
                                                                </span>
                                                            </>
                                                        )
                                                        }
                                                    </button>
                                                </div>
                                            </div>

                                        </Modal>
                                    )}
                                </>
                            )}
                            <FeatureHighlights />
                        </div>



                    </div>
                    {/* <div style={{ maxWidth: "703px", margin: "40px auto" }}>
                        <div className="d-flex justify-content-center flex-wrap" >
                            <div style={{ marginRight: "40px", marginBottom: "20px" }}>
                                <div
                                    className="d-flex align-items-center "
                                    style={{ cursor: "pointer" }}
                                >
                                    <img
                                        src="/img/hero/featurestrim.png"
                                        style={{ marginRight: "10px" }}
                                        alt="Voice-Trim"
                                    />
                                    <p
                                        className="mb-0"
                                        style={{ fontSize: "16px", color: "#94A3B8", fontWeight: "500" }}
                                    >
                                        Trim
                                    </p>
                                </div>
                            </div>
                            <div style={{ marginRight: "40px", marginBottom: "20px" }}>
                                <div
                                    className="d-flex align-items-center "
                                    style={{ cursor: "pointer" }}
                                >
                                    <img
                                        src="/img/hero/featuresmerge.png"
                                        style={{ marginRight: "10px" }}
                                        alt="Voice-Merge"
                                    />
                                    <p
                                        className="mb-0"
                                        style={{ fontSize: "16px", color: "#94A3B8", fontWeight: "500" }}
                                    >
                                        Merge
                                    </p>
                                </div>
                            </div>
                            <div style={{ marginRight: "40px", marginBottom: "20px" }}>
                                <div
                                    className="d-flex align-items-center "
                                    style={{ cursor: "pointer" }}
                                >
                                    <img
                                        src="/img/hero/featuresconvert.png"
                                        style={{ marginRight: "10px" }}
                                        alt="Voice-convert"
                                    />
                                    <p
                                        className="mb-0"
                                        style={{ fontSize: "16px", color: "#94A3B8", fontWeight: "500" }}
                                    >
                                        Convert
                                    </p>
                                </div>
                            </div>
                            <div style={{ marginRight: "40px", marginBottom: "20px" }}>
                                <div
                                    className="d-flex align-items-center "
                                    style={{ cursor: "pointer" }}
                                >
                                    <img
                                        src="/img/hero/featurestranscript.png"
                                        style={{ marginRight: "10px" }}
                                        alt="feature-transcript"
                                    />
                                    <p
                                        className="mb-0"
                                        style={{ fontSize: "16px", color: "#94A3B8", fontWeight: "500" }}
                                    >
                                        Transcript
                                    </p>
                                </div>
                            </div>
                            <div style={{ marginRight: "40px", marginBottom: "20px" }}>
                                <div
                                    className="d-flex align-items-center "
                                    style={{ cursor: "pointer" }}
                                >
                                    <img
                                        src="/img/hero/featurescloudsync.png"
                                        style={{ marginRight: "10px" }}
                                        alt="cloudsync"
                                    />
                                    <p
                                        className="mb-0"
                                        style={{ fontSize: "16px", color: "#94A3B8", fontWeight: "500" }}
                                    >
                                        Cloud Sync
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>

                {/* Voice Over Recording */}
                <div style={{ padding: "60px 0" }}>
                    <div className="row column_reverse">
                        <div className="col- col-sm-12 col-md-6 col-lg-6 d-flex flex-column justify-content-center">
                            <h6
                                style={{
                                    fontSize: "18px",
                                    fontWeight: "600",
                                    textTransform: "uppercase",
                                    marginBottom: '8px'
                                }}
                            >
                                Record & Edit Professional Voice overs
                            </h6>
                            <h2 style={{ fontSize: "48px", fontWeight: "700", letterSpacing: '-1px' }}>
                                Hassle-free Voice Over Recording
                            </h2>
                            <p
                                style={{
                                    fontSize: "18px",
                                    fontWeight: "400",
                                    fontFamily: "Metropolis",
                                    color: "#5F626B",
                                    maxWidth: "483px",
                                    marginBottom: "42px",
                                    wordSpacing: '1px',
                                    // lineHeight: "26px"
                                }}
                            >
                                Produce high-quality voice overs in no time. Use our free voice recorder to record your own voice, capturing special moments, important discussions, and creative ideas on the go.
                            </p>
                            <Button btnText={"Try Recording Now"} primary arrow onClick={() => handleGetStarted()} />
                        </div>
                        <div className="col- col-sm-12 col-md-6 col-lg-6 ">
                            <img
                                src="/img/hero/voiseover.png"
                                className="column_reverse_img_gap"
                                style={{ width: "100%", objectFit: "contain" }}
                                alt="voice-over-recording"
                            />
                        </div>
                    </div>
                </div>
            </div >

            {/* Voice Recorder Features */}

            <div
                id="features-section"
                style={{ padding: "60px 0", background: "#F8FAFC" }
                }
            >
                <div className="container">
                    <h3 className="text-center" style={{ marginBottom: "40px", letterSpacing: "-1px" }}>
                        All You Need In A High-Quality Voice Recorder Features
                    </h3>

                    <div>
                        <Slider {...settings} ref={sliderRef}>
                            {featuresData.map((item, index) => (
                                <div key={index} className="slider_main">
                                    <div className="card_slider">
                                        <img
                                            src={item.icon}
                                            alt={item.altIcon}
                                            style={{ marginBottom: "20px" }}
                                        />
                                        <h4 style={{ marginBottom: "5px" }}>{item.title}</h4>
                                        <p
                                            style={{
                                                marginBottom: "20px",
                                                color: "#5F626B",
                                                fontSize: "14px",
                                                fontWeight: "400",
                                            }}
                                        >
                                            {item.des}
                                        </p>
                                        <img
                                            src={item.img}
                                            alt={item.altImg}
                                            style={{ width: "100%", objectFit: "contain" }}
                                        />
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>


                    <div style={{ display: "flex", justifyContent: "end" }}>
                        {currentSlide > 0 && ( // Only render Previous button if not on the first slide
                            <button
                                onClick={handlePreviousClick}
                                style={{
                                    border: "none",
                                    display: "flex",
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '50px',
                                    width: '50px',
                                    borderRadius: "50%",
                                    background: "#334155",
                                    marginRight: "10px",
                                    marginTop: "32px",
                                }}
                            >
                                <img src="/img/arrowLeft.png" alt="Previous" style={{ width: "21px" }} />
                            </button>
                        )}
                        <button
                            onClick={handleNextClick}
                            style={{
                                border: "none",
                                borderRadius: "50%",
                                background: "#334155",
                                marginRight: "30px",
                                marginTop: "32px",
                                display: "flex",
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '50px',
                                width: '50px',


                            }}
                        >
                            <img src="/img/arrowright.png" alt="Next" style={{ width: "21px" }} />
                        </button>
                    </div>
                </div>
            </div>
            <div className="container">
                {/* Voice Over Recording */}
                <div style={{ padding: "60px 0" }}>
                    <div className="row">
                        <div className="col- col-sm-12 col-md-6 col-lg-6 ">
                            <img
                                src="/img/recording.png"
                                className="column_reverse_img_gap"
                                style={{ width: "100%", objectFit: "contain" }}
                                alt="Record-Edit-Share-Voice"
                            />
                        </div>
                        <div className="col- col-sm-12 col-md-6 col-lg-6 d-flex flex-column justify-content-center">
                            <div style={{ maxWidth: "523px", margin: "0 auto" }}>
                                <h6 style={{ marginBottom: "8px", fontSize: "40px", fontWeight: "700" }}>
                                    Edit & Share High-Quality Online Audio Recorder Anytime!
                                </h6>
                                <p style={{ marginBottom: "42px" }}>
                                    Seamlessly record and refine your voice with a few clicks with our free voice recorder.
                                </p>

                                <Button btnText={"Start Recording Now"} primary arrow onClick={() => {

                                    if (user) {
                                        navigate("/dashboard")
                                    } else if (!user && recordingStart) {
                                        handleSaveAudioRecording("isSignup")
                                        setAlertModal(true)
                                        setEventClick("isSignUp")
                                    }
                                    else {
                                        setSignUpModalOpen(true)
                                    }
                                    // handleStartRecordingScroll(); setRecordingStart(true); startRecording()
                                }}
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AiFeaturesSection onGetStarted={handleGetStarted} />
            <StepsSection />
            <WhyChooseSection />
            {/*  */}
            <div style={{ padding: "60px 0", background: "#F8FAFC" }} ref={sectionRef}>
                <div className="container">
                    <div>
                        <h3 className="text-center" style={{ fontSize: "34px", wordSpacing: "-1px" }}>
                            Record Everywhere- iOS, Android, and Web

                        </h3>
                        <p className="text-center" style={{ marginBottom: "30px" }}>
                            Download the voice recorder app for seamless recording, edits, and sharing.
                        </p>

                        {/* <div
                            className="d-flex justify-content-center"
                            style={{ marginBottom: "20px" }}
                        >
                            <img
                                src="/img/button/app-store.png"
                                style={{ marginRight: "20px" }}
                            />
                            <img src="/img/button/play-store.png" />
                        </div> */}

                        <div style={{ display: "flex", gap: "16px", justifyContent: "center" }}>
                            {/* App Store Link */}
                            <a
                                href="https://apps.apple.com/in/app/recording-app/id1537387586"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "black",
                                    color: "white",
                                    padding: "8px 16px",
                                    borderRadius: "8px",
                                    textDecoration: "none",
                                    width: "167px",
                                    position: "relative",
                                }}
                                target="_blank"
                                onMouseEnter={() => setShowAppStoreImage(true)}
                                onMouseLeave={() => setShowAppStoreImage(false)}
                            >
                                {showAppStoreImage && (
                                    <img
                                        src="/img/appstore.png"
                                        alt="App Store Hover"
                                        style={{
                                            position: "absolute",
                                            top: "-220px", // Adjust to position above the text
                                            left: "50%",
                                            transform: "translateX(-50%)",
                                            width: "200px",
                                            height: "200px",
                                            borderRadius: "8px",
                                            zIndex: "10", // Ensures it stays above other elements
                                        }}
                                    />
                                )}
                                <img
                                    src="/img/icon/app-store.png"
                                    alt="Apple logo"
                                    style={{ marginRight: "8px" }}
                                    height="30px"
                                />
                                <div>
                                    <div style={{ fontSize: "10px", fontWeight: "500" }}>Available on the</div>
                                    <div style={{ fontSize: "18px", fontWeight: "600" }}>App Store</div>
                                </div>
                            </a>

                            {/* Play Store Link */}
                            <a
                                href="https://play.google.com/store/apps/details?id=com.voicerecorder.memo&hl=en_US&gl=US"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "black",
                                    color: "white",
                                    padding: "8px 16px",
                                    borderRadius: "8px",
                                    textDecoration: "none",
                                    width: "167px",
                                    position: "relative",
                                }}
                                target="_blank"
                                onMouseEnter={() => setShowPlayStoreImage(true)}
                                onMouseLeave={() => setShowPlayStoreImage(false)}
                            >
                                {showPlayStoreImage && (
                                    <img
                                        src="/img/playstore.png"
                                        alt="Google Play Hover"
                                        style={{
                                            position: "absolute",
                                            top: "-220px", // Adjust to position above the text
                                            left: "50%",
                                            transform: "translateX(-50%)",
                                            width: "200px",
                                            height: "200px",
                                            borderRadius: "8px",
                                            zIndex: "10", // Ensures it stays above other elements
                                        }}
                                    />
                                )}
                                <img
                                    src="/img/icon/play-store.png"
                                    alt="Google Play logo"
                                    style={{ marginRight: "8px" }}
                                    height="25px"
                                />
                                <div>
                                    <div style={{ fontSize: "10px", fontWeight: "500" }}>GET IT ON</div>
                                    <div style={{ fontSize: "18px", fontWeight: "600" }}>Google Play</div>
                                </div>
                            </a>
                        </div>
                        <div className="d-flex justify-content-center">
                            <img
                                // src="/img/devices/devices1.png"
                                src="/img/devices/devices2.png"
                                style={{ width: "100%", objectFit: "contain" }}
                                alt="Voice-recoder-iOS-Android-web"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <BlogSection />

            {/*  */}
            <div className="container">
                <div style={{ padding: "60px 0" }}>
                    <h3 className="text-center" style={{ marginBottom: "40px" }}>
                        Frequently Asked Questions
                    </h3>
                    <div style={{ maxWidth: "864px", margin: "0 auto" }}>
                        <FAQAccordion />
                    </div>
                </div>
            </div>

            {/* - */}
            <UserReviews />

            {/* <div style={{ padding: "60px 0" }
            }>
                <h3 className="text-center" style={{ marginBottom: "30px" }}>
                    What People Say About Voice Recorder
                </h3>
                <div className="row gy-4 g-0">
                    <div
                        className="col- col-sm-12 col-md-6 col-lg-3"
                        style={{ padding: "0px 14px" }}
                    >
                        <div
                            style={{
                                background: "#F1F5F9",
                                padding: "40px",
                                borderRadius: "10px",
                            }}
                        >
                            <p style={{ marginBottom: "14px", color: "#94A3B8" }}>iOS User</p>
                            <div style={{ textAlign: "center" }}>
                                <img
                                    src="/img/rating.png"
                                    alt="rating"
                                    style={{ marginBottom: "14px" }}
                                />
                                <h6 style={{ marginBottom: "14px", fontWeight: '500', fontFamily: 'Metropolis', fontSize: "24px", letterSpacing: "-1px" }}>“Amazing app”</h6>
                                <p
                                    style={{
                                        fontFamily: "Inter",
                                        fontWeight: "400",
                                        fontStyle: "italic",
                                    }}
                                >
                                    So far, the best fitness app I have ever seen. Makes you work
                                    towards a goal, you have a specific plan for your body type
                                    and goal! Very happy with it!
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        className="col- col-sm-12 col-md-6 col-lg-3"
                        style={{ padding: "0px 14px" }}
                    >
                        <div
                            style={{
                                background: "#F1F5F9",
                                padding: "40px",
                                borderRadius: "10px",
                            }}
                        >
                            <p style={{ marginBottom: "14px", color: "#94A3B8" }}>
                                Android User
                            </p>
                            <div style={{ textAlign: "center" }}>
                                <img
                                    src="/img/rating.png"
                                    alt="rating"
                                    style={{ marginBottom: "14px" }}
                                />
                                <h6 style={{ marginBottom: "14px", fontWeight: '500', fontFamily: 'Metropolis', fontSize: "24px", letterSpacing: "-1px" }}>“Very impressed!”</h6>
                                <p
                                    style={{
                                        fontFamily: "Inter",
                                        fontWeight: "400",
                                        fontStyle: "italic",
                                    }}
                                >
                                    So far, the best fitness app I have ever seen. Makes you work
                                    towards a goal, you have a specific plan for your body type
                                    and goal! Very happy with it!
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        className="col- col-sm-12 col-md-6 col-lg-3"
                        style={{ padding: "0px 14px" }}
                    >
                        <div
                            style={{
                                background: "#F1F5F9",
                                padding: "40px",
                                borderRadius: "10px",
                            }}
                        >
                            <p style={{ marginBottom: "14px", color: "#94A3B8" }}>iOS User</p>
                            <div style={{ textAlign: "center" }}>
                                <img
                                    src="/img/rating.png"
                                    alt="rating"
                                    style={{ marginBottom: "14px" }}
                                />
                                <h6 style={{ marginBottom: "14px", fontWeight: '500', fontFamily: 'Metropolis', fontSize: "24px", letterSpacing: "-1px" }}>“Amazing app”</h6>
                                <p
                                    style={{
                                        fontFamily: "Inter",
                                        fontWeight: "400",
                                        fontStyle: "italic",
                                    }}
                                >
                                    So far, the best fitness app I have ever seen. Makes you work
                                    towards a goal, you have a specific plan for your body type
                                    and goal! Very happy with it!
                                </p>
                            </div>
                        </div>
                    </div>

                    <div
                        className="col- col-sm-12 col-md-6 col-lg-3"
                        style={{ padding: "0px 14px" }}
                    >
                        <div
                            style={{
                                background: "#F1F5F9",
                                padding: "40px",
                                borderRadius: "10px",

                            }}
                        >
                            <p style={{ marginBottom: "14px", color: "#94A3B8" }}>iOS User</p>
                            <div style={{ textAlign: "center" }}>
                                <img
                                    src="/img/rating.png"
                                    alt="rating"
                                    style={{ marginBottom: "14px" }}
                                />
                                <h6 style={{ marginBottom: "14px", fontWeight: '500', fontFamily: 'Metropolis', fontSize: "24px", letterSpacing: "-1px" }}>“Amazing app”</h6>
                                <p
                                    style={{
                                        fontFamily: "Inter",
                                        fontWeight: "400",
                                        fontStyle: "italic",
                                    }}
                                >
                                    So far, the best fitness app I have ever seen. Makes you work
                                    towards a goal, you have a specific plan for your body type
                                    and goal! Very happy with it!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            {
                signUpModalOpen && (
                    <CreateAccountModal
                        closeModal={signUpCloseModal}
                        openModal={loginOpenModal}
                    />
                )
            }
            {
                loginModalOpen && (
                    <LoginModal closeModal={loginCloseModal} openModal={signUpOpenModal} />
                )
            }
            {
                alertModal && (
                    <Modal
                        onClose={() => setAlertModal(false)}
                        modaltxt={"Voice Recorder"}

                    >
                        <div onClick={(e) => e.stopPropagation()}>
                            <div className="form-group mb-4" >
                                <p>Proceeding with this action may result in the loss of the current audio recording. To preserve your recording, please select "Download & Proceed." Alternatively, click "Discard" to continue without saving.</p>
                            </div>

                            <div className="form-group" style={{ display: 'flex', gap: '10px', margin: '2px' }}>
                                {/* Continue Signup (Discard Recording) */}
                                {/* <button
                                    type="button"
                                    className="btn p-3"
                                    style={{
                                        width: "100%",
                                        borderRadius: "8px",
                                        background: "red",
                                        fontSize: "16px",
                                        fontWeight: "700",
                                        color: "#FFFFFF",
                                    }}
                                    onClick={() => {
                                        setAlertModal(false);
                                        if (eventClick == "isSignUp") {

                                            setSignUpModalOpen(true); // Assuming you have a state for signup modal
                                        } else if (eventClick == "isPricing") {
                                            navigate('/pricing')
                                        }
                                        setRecordingStart(false);
                                        setIsLoginCancel(false);
                                        setBtnToggl(false);
                                        setElapsedTime(0)

                                    }}
                                >
                                    <span>Discard</span>

                                </button> */}

                                <button
                                    type="button"
                                    className="btn p-3"
                                    style={{
                                        width: "100%",
                                        fontSize: "16px",
                                        fontWeight: "700",
                                        border: "none",
                                        background: "#334155",
                                        borderRadius: "8px",
                                        padding: "14px 20px",
                                        cursor: "pointer",
                                        color: "#fff",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                    onClick={() => {
                                        handleDownloadClick();
                                        setAlertModal(false);
                                        if (eventClick == "isSignUp") {

                                            setSignUpModalOpen(true);
                                        } else if (eventClick == "isPricing") {
                                            navigate('/pricing')
                                        }
                                        setRecordingStart(false);
                                        setIsLoginCancel(false);
                                        setBtnToggl(false);
                                        setElapsedTime(0)
                                    }}
                                >

                                    <span style={{ fontWeight: "bold" }}>
                                        <img
                                            src={"/img/dashboard/download.png"}
                                            alt={"download"}
                                            style={{ marginRight: "10px" }}
                                        />
                                        Download & Proceed
                                    </span>
                                </button>


                            </div>
                            <a
                                className="form-group"
                                style={{
                                    color: "red",
                                    cursor: 'pointer',
                                    display: "flex",
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    marginTop: '10px'
                                }}
                                onClick={() => {
                                    setAlertModal(false);
                                    if (eventClick == "isSignUp") {

                                        setSignUpModalOpen(true); // Assuming you have a state for signup modal
                                    } else if (eventClick == "isPricing") {
                                        navigate('/pricing')
                                    }
                                    setRecordingStart(false);
                                    setIsLoginCancel(false);
                                    setBtnToggl(false);
                                    setElapsedTime(0)

                                }}

                            >

                                <span>Discard</span>
                            </a>
                        </div>
                    </Modal>
                )
            }
        </>
    );
};

export default HomePage;
